module.exports = __webpack_public_path__ + "img/9.74fd3b5d.png";